<template>
  <b-field>
    <div style="width: 250px; margin: auto;" class="columns is-mobile is-multiline is-gapless">
      <div style="min-height: 4rem; border: 1px solid lightgray; word-wrap: break-word; white-space: pre-wrap;"
           class="column is-full has-text-centered is-size-2 p-0">
        {{ showPin }}
      </div>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('1')">1
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('2')">2
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('3')">3
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('4')">4
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('5')">5
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('6')">6
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('7')">7
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('8')">8
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('9')">9
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('Backspace')"><i class="fas fa-backspace has-text-danger"></i></button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('0')">0
      </button>
      <button class="button is-medium column is-one-third has-text-weight-bold" :disabled="form.loading"
              @click="onNumpad('Enter')"><i class="fas fa-check has-text-success"></i></button>
    </div>
  </b-field>
</template>

<script>

const NUMBERS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']

export default {
  name: 'Keyboard',
  props: {
    isMask: Boolean
  },
  data() {
    return {
      form: {
        pin: '',
        loading: false
      }
    }
  },
  computed: {
    showPin() {
      if (this.isMask)
        return '*'.repeat(this.form.pin.length)
      else
        return this.form.pin
    },
  },
  mounted() {
    addEventListener('keypress', e => {
      if (NUMBERS.includes(e.key)) {
        this.onNumpad(e.key)
      }
    })
    addEventListener('keyup', e => {
      if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Escape' || e.key === 'Enter') {
        this.onNumpad(e.key)
      }
    })
  },
  methods: {
    onNumpad(key) {
      if (this.form.loading) {
        return
      }
      if (key === 'Backspace' || key === 'Delete') {
        this.form.pin = this.form.pin.length ? this.form.pin.substr(0, this.form.pin.length - 1) : ''
      } else if (key === 'Escape') {
        this.form.pin = ''
      } else if (key === 'Enter') {
        this.onEnter()
      } else {
        this.form.pin += key
      }
    },
    onEnter() {
      let me = this
      console.log(this.form.pin)
      this.form.loading = true
      this.$emit('onSubmit', this.form.pin, function(){
        me.form.loading = false
        me.form.pin = ''
      })
    }
  }
}
</script>
